import type { profile as en } from '@/i18n/locales/en/profile';
import type { Translation } from '@/i18n/types';

export const profile: Translation<typeof en> = {
  title: 'Profilo',
  lead: 'Il tuo nome, la lingua e le impostazioni sulla privacy.',
  pendingBadge: '{{count}} richiesta di consenso in sospeso',
  nav: {
    label: 'Menu del profilo',
    profile: 'Profilo',
    consents: 'Consensi',
    preferences: 'Preferenze',
    subscription: 'Abbonamento',
  },
  preferredLanguage: 'Lingua preferita',
  preferredLanguageOptional: 'Lingua preferita (opzionale)',
  preferredLanguageUnset: 'Non impostata',
  timezoneUnset: 'Predefinito del deployment',
  saved: 'Salvato.',
  save: 'Salva',
  privateFieldsHint:
    'Questi quattro campi sono privati — solo tu puoi vederli o modificarli, chiunque altro possa vedere il resto del tuo profilo.',
  details: {
    title: 'Dati',
    rolesTitle: 'Ruoli',
  },
  regionAndTimezone: {
    title: 'Regione e fuso orario',
  },
  fields: {
    name: 'Nome',
    email: 'E-mail',
    nickname: 'Soprannome',
    region: 'Regione',
    regionUnset: 'Non impostata',
    regionHint: 'Il paese per cui vengono localizzate le tue statistiche/i tuoi report.',
    timezone: 'Fuso orario per le statistiche',
    timezoneHint: 'Il calendario con cui vengono chiusi i tuoi giorni di statistiche.',
    gender: 'Genere',
    birthdate: 'Data di nascita',
    height: 'Altezza (cm)',
    weight: 'Peso (kg)',
  },
};
